import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from '@material-ui/core';
import { isFunction } from 'lodash';
import PropTypes from 'prop-types';

import * as S from '../../styles';

export default function Tabela({
  title,
  cells,
  data,
  height,
  size,
  onIconClick,
}) {
  const [selectedRow, setSelectedRow] = React.useState(null);

  const handleRowClick = (row) => {
    setSelectedRow(row);
  };

  return (
    <S.WrapperTabela height={height}>
      <S.WrapperTitle>{title}</S.WrapperTitle>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size={size}>
          <TableHead>
            <TableRow>
              {cells.map((cell, index) => (
                <TableCell
                  key={`cell-index-head-${index}`}
                  align={cell.align || 'left'}
                >
                  {cell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow
                hover
                tabIndex={-1}
                key={`table-row-body-${index}`}
                onClick={() => handleRowClick(item)}
              >
                {cells.map((cell, indexKey) => {
                  return (
                    <TableCell
                      key={`table-cell-body-${indexKey}`}
                      align={cell.align || 'left'}
                    >
                      <Box
                        display="flex"
                        // alignItems="center"
                        alignItems={cell.align || 'center'}
                        style={{
                          justifyContent:
                            cell.id === 'acao' ? 'flex-end' : 'start',
                        }}
                      >
                        {cell.format && (
                          <>
                            {!cell.action && (
                              <label
                                style={
                                  isFunction(cell.styled)
                                    ? cell.styled(item[cell.id])
                                    : { textAlign: cell.align, flex: 1 }
                                }
                              >
                                {cell.format(item[cell.id])}
                              </label>
                            )}
                          </>
                        )}
                        {!cell.format && (
                          <label
                            style={
                              isFunction(cell.styled)
                                ? cell.styled(item[cell.id])
                                : {}
                            }
                          >
                            {item[cell.id]}
                          </label>
                        )}
                        {cell.action &&
                          cell.action.map((acao) => (
                            <div
                              title={
                                acao.edicao === 'abastecimento'
                                  ? item.statuslibintegraatendimentoabastecimento ===
                                    1
                                    ? `Pendente manual ${acao.label}`
                                    : item.statuslibintegraatendimentoabastecimento ===
                                        0 ||
                                      item.statuslibintegraatendimentoabastecimento ===
                                        2
                                    ? `Aprovado ${acao.label}`
                                    : item.statuslibintegraatendimentoabastecimento ===
                                      3
                                    ? `Nao Aprovado ${acao.label}`
                                    : item.statuslibintegraatendimentoabastecimento ===
                                      4
                                    ? `Reenvio Aprovacao ${acao.label}`
                                    : acao.label
                                  : item.statuslibintegraatendimentolubrificacao ===
                                    1
                                  ? `Pendente manual ${acao.label}`
                                  : item.statuslibintegraatendimentolubrificacao ===
                                      0 ||
                                    item.statuslibintegraatendimentolubrificacao ===
                                      2
                                  ? `Aprovado ${acao.label}`
                                  : item.statuslibintegraatendimentolubrificacao ===
                                    3
                                  ? `Nao Aprovado ${acao.label}`
                                  : item.statuslibintegraatendimentolubrificacao ===
                                    4
                                  ? `Reenvio Aprovacao ${acao.label}`
                                  : acao.label
                              }
                            >
                              {
                                <>
                                  {item.atendimentoFechado === 'S' &&
                                  acao.edicao === 'abastecimento' &&
                                  (item.statuslibintegraatendimentoabastecimento ===
                                    1 ||
                                    item.statuslibintegraatendimentoabastecimento ===
                                      3 ||
                                    item.statuslibintegraatendimentoabastecimento ===
                                      4) ? (
                                    <acao.botao
                                      style={
                                        isFunction(cell.styledIcon)
                                          ? cell.styledIcon(item[cell.id])
                                          : {
                                              marginLeft: item[cell.id] ? 8 : 0,
                                              color: '#999999',
                                              cursor: 'pointer',
                                            }
                                      }
                                      onClick={() =>
                                        onIconClick(
                                          acao.edicao,
                                          item.atendimentoFechado,
                                          item.idatendimento,
                                          item.idveiculo,
                                          acao?.origem,
                                          item?.idmovimentacao,
                                          item?.idposto,
                                          item?.statuslibintegraatendimentolubrificacao,
                                          item?.statuslibintegraatendimentoabastecimento
                                        )
                                      }
                                    />
                                  ) : item.atendimentoFechado === 'S' &&
                                    acao.edicao === 'lubrificacao' &&
                                    (item.statuslibintegraatendimentolubrificacao ===
                                      1 ||
                                      item.statuslibintegraatendimentolubrificacao ===
                                        3 ||
                                      item.statuslibintegraatendimentolubrificacao ===
                                        4) ? (
                                    <acao.botao
                                      style={
                                        isFunction(cell.styledIcon)
                                          ? cell.styledIcon(item[cell.id])
                                          : {
                                              marginLeft: item[cell.id] ? 8 : 0,
                                              color: '#999999',
                                              cursor: 'pointer',
                                            }
                                      }
                                      onClick={() =>
                                        onIconClick(
                                          acao.edicao,
                                          item.atendimentoFechado,
                                          item.idatendimento,
                                          item.idveiculo,
                                          acao?.origem,
                                          item?.idmovimentacao,
                                          item?.idposto,
                                          item?.statuslibintegraatendimentolubrificacao,
                                          item?.statuslibintegraatendimentoabastecimento
                                        )
                                      }
                                    />
                                  ) : (
                                    <acao.botao
                                      style={
                                        isFunction(cell.styledIcon)
                                          ? cell.styledIcon(item[cell.id])
                                          : {
                                              marginLeft: item[cell.id] ? 8 : 0,
                                              color: '#999999',
                                              cursor: 'pointer',
                                            }
                                      }
                                      onClick={() =>
                                        toast.error('Registro já foi aprovado!')
                                      }
                                      // onClick={() =>
                                      //   onIconClick(
                                      //     acao.edicao,
                                      //     item.atendimentoFechado,
                                      //     item.idatendimento,
                                      //     item.idveiculo,
                                      //     acao?.origem,
                                      //     item?.idmovimentacao,
                                      //     item?.idposto,
                                      //     item?.statuslibintegraatendimentolubrificacao,
                                      //     item?.statuslibintegraatendimentoabastecimento,
                                      //   )
                                      // }
                                    />
                                  )}
                                </>
                              }
                            </div>
                            // <div title={acao.label}>
                            //   {item.atendimentoFechado !== 'S' &&
                            //   acao.edicao !== 'emitir' ? (
                            //     <acao.botao
                            //       style={
                            //         isFunction(cell.styledIcon)
                            //           ? cell.styledIcon(item[cell.id])
                            //           : {
                            //               marginLeft: item[cell.id] ? 8 : 0,
                            //               color: '#999999',
                            //               cursor: 'pointer',
                            //             }
                            //       }
                            //       onClick={() =>
                            //         onIconClick(
                            //           acao.edicao,
                            //           item.atendimentoFechado,
                            //           item.idatendimento,
                            //           item.idveiculo,
                            //           acao?.origem,
                            //           item?.idmovimentacao,
                            //           item?.idposto,
                            //           item?.statuslibintegraatendimentolubrificacao,
                            //           item?.statuslibintegraatendimentoabastecimento,
                            //         )
                            //       }
                            //     />
                            //   ) : (
                            //     <>
                            //       {acao.edicao !== 'fim' &&
                            //         item.atendimentoFechado === 'S' && (
                            //           <acao.botao
                            //             style={
                            //               isFunction(cell.styledIcon)
                            //                 ? cell.styledIcon(item[cell.id])
                            //                 : {
                            //                     marginLeft: item[cell.id]
                            //                       ? 8
                            //                       : 0,
                            //                     color: '#999999',
                            //                     cursor: 'pointer',
                            //                   }
                            //             }
                            //             onClick={() =>
                            //               onIconClick(
                            //                 acao.edicao,
                            //                 item.atendimentoFechado,
                            //                 item.idatendimento,
                            //                 item.idveiculo,
                            //                 acao?.origem,
                            //                 item?.idmovimentacao,
                            //                 item?.idposto,
                            //                 item?.statuslibintegraatendimentolubrificacao,
                            //                 item?.statuslibintegraatendimentoabastecimento,
                            //               )
                            //             }
                            //           />
                            //         )}
                            //     </>
                            //   )}
                            // </div>
                          ))}
                      </Box>
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.WrapperTabela>
  );
}

Tabela.propTypes = {
  title: PropTypes.string.isRequired,
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      align: PropTypes.string,
      format: PropTypes.func,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  height: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  showDefaultValue: PropTypes.string,
};

Tabela.defaultProps = {
  height: '100%',
  size: 'medium',
  showDefaultValue: 'S',
};
